import UIFetchService from "../Service/UIFetchService";
import { isEmpty } from "../Service/Utils";

import {
  Divider,
  Button,
  Modal,
  Input,
  Row,
  Col,
  message,
  Table,
  Space,
  Cascader,
} from "antd";
import {
  ExclamationCircleOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import React from "react";
import TableSelector from "./TableSelector";

class UtilsView extends React.Component {
  constructor() {
    super();
    this.state = {
      syncSchemasPending: false,
      computeUsageHeatPending: false,
      schemaDenies: [],
      schemaDenyName: "",
      dailyReportPending: false,
      referralDailyReportPending: false,
      weeklyReportPending: false,
      monthlyReportPending: false,
      groupSkuDailyReportPending: false,
      abroadDailyReportPending: false,
      projectOptions: [
        {
          label: "MaxCompute",
          value: "ODPS",
          children: [],
        },
        {
          label: "Hologres",
          value: "Hologres",
          children: [],
        },
      ],
      selectedOriginProjectForMeta: [],
      selectedOriginProjectForDeny: [],
    };
  }

  async componentDidMount() {
    UIFetchService.get(
      "/api/v1/utils/querying_works/schemas/denies?origin=ODPS&projectName=bcz_datap"
    ).then((schemaDenies) => {
      if (schemaDenies) {
        this.setState({ schemaDenies });
      }
    });

    UIFetchService.get("/api/v1/schema/projects").then((projects) => {
      if (projects) {
        // const maxComputeOption = this.state.projectOptions[0];
        // maxComputeOption.children = projects?.ODPS?.map((p) => {
        //   return {
        //     label: p,
        //     value: p,
        //   };
        // });
        // const hologresOption = this.state.projectOptions[1];
        // hologresOption.children = projects?.Hologres?.map((p) => {
        //   return {
        //     label: p,
        //     value: p,
        //   };
        // });
        this.setState({
          projectOptions: [
            {
              label: "MaxCompute",
              value: "ODPS",
              children:
                projects?.ODPS?.map((p) => {
                  return {
                    label: p,
                    value: p,
                  };
                }) || [],
            },
            {
              label: "Hologres",
              value: "Hologres",
              children:
                projects?.Hologres?.map((p) => {
                  return {
                    label: p,
                    value: p,
                  };
                }) || [],
            },
          ],
        });
        this.setState({
          selectedOriginProjectForMeta: ["ODPS", "bcz_datap"],
          selectedOriginProjectForDeny: ["ODPS", "bcz_datap"],
        });
      }
    });
  }

  render() {
    return (
      <>
        <Row>
          <h2>日报/周报/月报-重新发送</h2>
        </Row>
        <Row>
          <Col>
            <Space>
              <Button
                disabled={this.state.dailyReportPending}
                danger
                type="primary"
                onClick={this.sendDailyReport.bind(this)}
              >
                {"重发<<日报>>"}
              </Button>
              <Button
                disabled={this.state.referralDailyReportPending}
                danger
                type="primary"
                onClick={this.sendReferralDailyReport.bind(this)}
              >
                {"重发<<导流日报>>"}
              </Button>
              <Button
                disabled={this.state.weeklyReportPending}
                danger
                type="primary"
                onClick={this.sendWeeklyReport.bind(this)}
              >
                {"重发<<周报>>"}
              </Button>
              <Button
                disabled={this.state.monthlyReportPending}
                danger
                type="primary"
                onClick={this.sendMonthlyReport.bind(this)}
              >
                {"重发<<月报>>"}
              </Button>
              <Button
                disabled={this.state.groupSkuDailyReportPending}
                danger
                type="primary"
                onClick={this.sendGroupSkuDailyReport.bind(this)}
              >
                {"重发<<大营收日报>>"}
              </Button>
              <Button
                disabled={this.state.abroadDailyReportPending}
                danger
                type="primary"
                onClick={this.sendAbroadDailyReport.bind(this)}
              >
                {"重发<<出国日报>>"}
              </Button>
            </Space>
          </Col>
        </Row>
        <Divider />
        <Row>
          <h2>自助查询-元数据管理</h2>
        </Row>
        <Row>
          <Col span={2} style={{ alignSelf: "center", textAlign: "left" }}>
            <span>增加或更新表：</span>
          </Col>
          <Col span={6}>
            {/* <TableSelector
              value={this.state.selectedOriginProjectForMeta}
              allowClear={false}
              options={this.state.projectOptions}
              onChange={this.onOriginProjectChangeForMeta.bind(this)}
            /> */}
            <Cascader
              style={{ width: "90%" }}
              value={this.state.selectedOriginProjectForMeta}
              allowClear={false}
              options={this.state.projectOptions}
              onChange={this.onOriginProjectChangeForMeta.bind(this)}
            />
          </Col>
          <Col span={6}>
            <Input
              style={{ width: "100%" }}
              placeholder="多个表名用逗号(,)分割"
              value={this.state.syncSchemas}
              onChange={(e) => this.setState({ syncSchemas: e.target.value })}
              disabled={this.state.syncSchemasPending}
            ></Input>
          </Col>
          <Col span={2}>
            <Button
              type="primary"
              disabled={this.state.syncSchemasPending}
              onClick={this.syncSpecifiedSchemas.bind(this)}
            >
              更新
            </Button>
          </Col>
          <Col span={2}>
            <Button
              danger
              type="primary"
              disabled={this.state.syncSchemasPending}
              onClick={this.syncAllSchemas.bind(this)}
            >
              更新全部
            </Button>
          </Col>
        </Row>
        <div style={{ height: 10 }}></div>
        <Row>
          <Col span={3} style={{ alignSelf: "center", textAlign: "left" }}>
            <span>重新计算表使用热度：</span>
          </Col>
          <Col span={2}>
            <Button
              type="primary"
              disabled={
                this.state.syncSchemasPending ||
                this.state.computeUsageHeatPending
              }
              onClick={this.computeUsageHeat.bind(this)}
            >
              开始
            </Button>
          </Col>
        </Row>
        <Divider />
        <Row>
          <h2>自助查询-黑名单管理</h2>
        </Row>
        <Row>
          <Col>
            <Space>
              <span>加入黑名单:</span>
              {/* <TableSelector
                value={this.state.selectedOriginProjectForDeny}
                allowClear={false}
                options={this.state.projectOptions}
                onChange={this.onOriginProjectChangeForDeny.bind(this)}
              /> */}
              <Cascader
                style={{ width: 300 }}
                value={this.state.selectedOriginProjectForDeny}
                allowClear={false}
                options={this.state.projectOptions}
                onChange={this.onOriginProjectChangeForDeny.bind(this)}
              />
              <Input
                style={{ width: 400 }}
                value={this.state.schemaDenyName}
                onChange={({ target: { value } }) =>
                  this.setState({ schemaDenyName: value })
                }
              ></Input>
              <Button
                icon={<PlusOutlined />}
                disabled={isEmpty(this.state.schemaDenyName)}
                onClick={this.addSchemaDeny.bind(this)}
              >
                添加
              </Button>
            </Space>
          </Col>
        </Row>
        <div style={{ height: 10 }}></div>
        <Row>
          <Table
            dataSource={this.state.schemaDenies}
            pagination={false}
            size="small"
            bordered
          >
            <Table.Column
              title="更新时间"
              dataIndex="createdAt"
              key="createdAt"
              width={200}
            />
            <Table.Column
              title="表名"
              dataIndex="name"
              key="name"
              width={400}
            />
            <Table.Column
              title="操作"
              render={(_, record) => (
                <Space>
                  <Button
                    icon={<CloseOutlined />}
                    size="small"
                    onClick={() => this.removeSchemaDeny(record.name)}
                  ></Button>
                </Space>
              )}
            />
          </Table>
        </Row>
      </>
    );
  }

  onOriginProjectChangeForMeta(value) {
    this.setState({
      selectedOriginProjectForMeta: value,
    });
  }

  onOriginProjectChangeForDeny(value) {
    this.setState(
      {
        selectedOriginProjectForDeny: value,
      },
      () => {
        this.fetchSchemaDenies();
      }
    );
  }

  async fetchSchemaDenies() {
    const origin = this.state.selectedOriginProjectForDeny[0];
    const project =
      this.state.selectedOriginProjectForDeny[1] == null
        ? ""
        : this.state.selectedOriginProjectForDeny[1];
    UIFetchService.get(
      `/api/v1/utils/querying_works/schemas/denies?origin=${origin}&projectName=${project}`
    ).then((schemaDenies) => {
      if (schemaDenies) {
        this.setState({ schemaDenies });
      }
    });
  }

  async sendDailyReport() {
    this.setState({ dailyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/daily/report`, {});
    this.setState({ dailyReportPending: false });
  }

  async sendWeeklyReport() {
    this.setState({ weeklyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/weekly/report`, {});
    this.setState({ weeklyReportPending: false });
  }

  async sendReferralDailyReport() {
    this.setState({ referralDailyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/referral_daily/report`, {});
    this.setState({ referralDailyReportPending: false });
  }

  async sendMonthlyReport() {
    this.setState({ monthlyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/monthly/report`, {});
    this.setState({ monthlyReportPending: false });
  }

  async sendGroupSkuDailyReport() {
    this.setState({ groupSkuDailyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/group_sku_daily/report`, {});
    this.setState({ groupSkuDailyReportPending: false });
  }

  async sendAbroadDailyReport() {
    this.setState({ abroadDailyReportPending: true });
    await UIFetchService.post(`/api/v1/utils/abroad_daily/report`, {});
    this.setState({ abroadDailyReportPending: false });
  }

  async removeSchemaDeny(name) {
    const origin = this.state.selectedOriginProjectForDeny[0];
    const project =
      this.state.selectedOriginProjectForDeny[1] == null
        ? ""
        : this.state.selectedOriginProjectForDeny[1];
    await UIFetchService.method(
      "DELETE",
      `/api/v1/utils/querying_works/schemas/denies/${name}?origin=${origin}&projectName=${project}`
    );

    this.fetchSchemaDenies();
  }

  async addSchemaDeny() {
    const origin = this.state.selectedOriginProjectForDeny[0];
    const project =
      this.state.selectedOriginProjectForDeny[1] == null
        ? ""
        : this.state.selectedOriginProjectForDeny[1];
    await UIFetchService.post(
      `/api/v1/utils/querying_works/schemas/denies/${this.state.schemaDenyName}?origin=${origin}&projectName=${project}`
    );
    this.setState({ schemaDenyName: "" });

    this.fetchSchemaDenies();
  }

  async syncSpecifiedSchemas() {
    const origin = this.state.selectedOriginProjectForMeta[0];
    const project =
      this.state.selectedOriginProjectForMeta[1] == null
        ? ""
        : this.state.selectedOriginProjectForMeta[1];
    const rv = await UIFetchService.post(
      `/api/v1/utils/querying_works/schemas/sync?origin=${origin}&projectName=${project}&names=${encodeURI(
        this.state.syncSchemas
      )}`,
      {}
    );
    if (rv === undefined) {
      return;
    }
    message.success(`更新成功: ${rv.count}`);
    this.setState({ syncSchemas: "" });
  }

  syncAllSchemas() {
    const onOk = () =>
      UIFetchService.post(
        "/api/v1/utils/querying_works/schemas/sync/all",
        {}
      ).then(() => {
        this.setState({ syncSchemasPending: true });
        setTimeout(() => {
          this.setState({ syncSchemasPending: false });
        }, 1000 * 30);
        message.success("同步任务启动");
      });
    const onCancel = () => {};

    Modal.confirm({
      title: "重新同步所有表信息，是否继续？",
      icon: <ExclamationCircleOutlined />,
      okText: "是",
      okType: "primary",
      cancelText: "否",
      onOk,
      onCancel,
    });
  }

  computeUsageHeat() {
    const onOk = () => {
      this.setState({ computeUsageHeatPending: true });
      UIFetchService.post(
        "/api/v1/utils/querying_works/schemas/usage_heat/all",
        {}
      ).then(() => {
        this.setState({ computeUsageHeatPending: false });
        message.success("表热度更新完成");
      });
    };
    const onCancel = () => {};

    Modal.confirm({
      title: "重新计算所有表的使用热度，是否继续？",
      icon: <ExclamationCircleOutlined />,
      okText: "是",
      okType: "primary",
      cancelText: "否",
      onOk,
      onCancel,
    });
  }
}

export default UtilsView;
